import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { UpdateAddressDetailsPayload } from '../sagas/types';

const addressesSlice = createSlice({
  name: 'addressesSlice',
  initialState: {},
  reducers: {
    updateAddressDetails: (_state, _action: PayloadAction<UpdateAddressDetailsPayload>) => {},
  },
});

export const { updateAddressDetails } = addressesSlice.actions;

export const addressesSliceReducerPath = addressesSlice.reducerPath;

export const addressesSliceReducer = addressesSlice.reducer;
